import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import {
  DRILLDOWN_BY_PAYMENT_TYPE,
  SUMMARY_BY_PAYMENT_TYPE,
  paymentTypeName,
} from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByPaymentTypePage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByPaymentTypeQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Payment Type" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Payment Type</h1>
      <OrdersCategoryList
        categoryTitle="PaymentType"
        columns={SUMMARY_BY_PAYMENT_TYPE}
        unit="payment type(s)"
        resizeStorageKey="orders-by-payment-type"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        // Rows group on the stored code; readers want the name.
        formatCategory={paymentTypeName}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders paid by ${paymentTypeName(row.category)}`}
            columns={DRILLDOWN_BY_PAYMENT_TYPE}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            paymentType={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByPaymentTypePage;
